<script setup lang="ts">
import ECharts from '@/components/Every24HoursReportPreviewParts/chart/ECharts.vue';
import { computed } from 'vue';
import i18n from '@/lang/i18n';

const emits = defineEmits(['update:modelValue']);

const props = defineProps<{
  modelValue: number
  type: string
  scaleMinMax: number[]
  chartData: number[][]
  displayData: number[][]
  xLabels: string[]
  verticalLines: {
    xAxis: number | null;
  }[]
  options: {
    grid: {
      left: string | number,
      top: string | number,
      bottom: string | number,
      width: string | number,
      height: string | number,
    },
    yAxis: {
      min: number,
      max: number,
      interval: number,
    }
  }
  chartLabels: string[]
  chartHeight: string
  changeMinMax: () => void
}>()

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
})
</script>
<template>
  <div
    class="mx-auto d-flex mb-6 "
    style="width: 85%;"
  >
    <div
      class="d-flex align-items-center bg-grey-darken-3 text-white p-3 rounded"
      style="width: 70px;"
    >
      <div class="mx-auto">
        {{ i18n.global.t(props.chartLabels[0]) }}
        <br>
        {{ i18n.global.t(props.chartLabels[1])}}
      </div>
    </div>
    <div class="w-100 d-flex flex-column align-items-center">
      <div class="w-100 bg-light rounded d-flex flex-column position-relative">
        <ECharts
          ref="eCharts"
          :type="props.type"
          :chartData="props.chartData"
          :displayData="props.displayData"
          :scaleMinMax="props.scaleMinMax"
          :options="props.options"
          :verticalLines="props.verticalLines"
          :chartHeight="props.chartHeight"
        />
      </div>
      <div class="w-100 mt-1">
        <div class="w-100 d-flex justify-content-between">
          <template
            v-for="(label, index) in props.xLabels"
            :key="index"
          >
            <p
              style="font-size: 12px;"
              class="x-label mb-0"
            >
              {{ label }}
            </p>
          </template>
        </div>
        <div
          style="width: 99%;"
          class="mx-auto"
        >
          <v-slider
            v-model="modelValue"
            step="1"
            track-fill-color="#2C7CFF"
            track-color="#DDDDDD"
            thumb-color="#2C7CFF"
            @end="props.changeMinMax()"
          />
        </div>
      </div>
    </div>
  </div>
</template>
